<template>
  <div v-loading="loading" class="registerb-box"
    element-loading-text="拼命注册中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="registerb" :id="pageId">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" >
      <div class="Rtitle" id="Rtitle">
        <span class="titlel">{{InsName}}</span><span class="titler"> | 账户注册</span>
      </div>
      <div class="Rmin" id="Rmin">
      <el-form-item prop="Name">
        <div class="error3">
         <span class="colorr">*</span> <span>真实姓名:</span>
        </div>
        <el-input v-model.trim="ruleForm.Name" placeholder="请输入姓名" id="name"  :disabled="IsSimulationinput"></el-input>
        <span class="error4 hint">用户名关联出金，需与真实姓名一致.</span>
      </el-form-item>
      <el-form-item prop="insUserCode" v-show="insTestProp.UseCustomId">
        <div class="error3">
         <span class="colorr">*</span> <span>用户账号:</span>
        </div>
        <el-input v-model.trim="ruleForm.insUserCode" placeholder="请输入账号"></el-input>
        <span class="error4 hint">请输入用户账号.</span>
      </el-form-item>
      <el-form-item prop="phone" v-show="insTestProp.UserRelyPhone">
        <div class="error3">
         <span class="colorr">*</span> 手机号:
        </div>
        <el-input v-model.trim="ruleForm.phone" placeholder="请输入手机号" id="phone"></el-input>
        <span class="error4 hint">请填写11位有效号码.</span>
      </el-form-item>
      <el-form-item prop="code" v-if="!insTestProp.UserRelyPhone" >
        <div class="error3">       
          <span class="colorr">*</span>图形验证码:
        </div>
        <el-input v-model.trim="ruleForm.code" placeholder="请输入图形验证码" ></el-input>
        <img :src="imgurl" alt="" class="imgcode" @click="GetImgCheckCode()">          
      </el-form-item>
      <el-form-item prop="phoneCode" v-show="insTestProp.UserRelyPhone">
        <div class="error3">
         <span class="colorr">*</span> 手机验证码:
        </div>
        <el-input v-model.trim="ruleForm.phoneCode" placeholder="请输入的验证码"  id="code"></el-input>
        <el-button type="primary" size="small" @click="sendCode()" :disabled="isDisabled">{{buttonName}}</el-button>    
      </el-form-item>
      <el-form-item  prop="pass">
        <div class="error3">
        <span class="colorr">*</span>  交易密码:
        </div>
        <el-input v-model.trim="ruleForm.pass" auto-complete="new-password" placeholder="请输入交易密码" type="password" id="pswd"></el-input>
        <span class="error4 hint" v-show="IsSimulation != '1'">包含大小写字母及数字，长度不得小于8位！</span>
      </el-form-item>
      <el-form-item prop="checkPass">
        <div class="error3" style="margin-top:10px">
        <span class="colorr">*</span>  确认交易密码:
        </div>
        <el-input v-model.trim="ruleForm.checkPass" placeholder="请再次输入交易密码" type="password" id="pswds"></el-input>
         <span class="error4 hint">请再次输入密码.</span>
      </el-form-item>
      <el-form-item    >
        <div class="error3">
        <span class="colorr" v-show="this.IsSimulationshow">*</span>  邀请码:
        </div>
        <el-input v-model.trim="ruleForm.Invitationcode"  placeholder="请输入邀请码"  id="Invitationcode"></el-input>
        <span class="error4 hint">请填写有效邀请码</span>
      </el-form-item>
        <el-checkbox v-model="checked" style="margin:15px 20px 0 100px;font-size:12px">我已阅读并同意</el-checkbox>
         <span class="cbule"  @click="dialogVisible = true">《交易系统使用风险揭示书》</span>
        <div class="bbtn">
          <el-button type="primary" @click="submitForm('ruleForm')" class="submit" :disabled="this.isDisableds">注册</el-button>
          <el-button @click="resetForm('ruleForm')" class="submit">重置</el-button>
        </div>
      </div>
    </el-form>
    <!-- 图形验证码 -->
    <el-dialog
      title="请先输入图形验证码"
      center=""
      v-loading="loadingDialog"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :modal-append-to-body="false" :close-on-click-modal="false"
      :visible.sync="dialogVisibleCode"
      class="dialog-code"
      width="35%">
      <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1">
        <el-form-item prop="code">
          <div class="error3">       
            <span class="colorr">*</span>图形验证码:
          </div>
          <el-input v-model.trim="ruleForm1.code" placeholder="请输入图形验证码" style="width:65%;"></el-input>
          <img :src="imgurl" alt="" class="imgcode" @click="GetImgCheckCode()">
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sendPhoneCode('ruleForm1')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 进入验证弹窗 -->
      <el-dialog class="dialog-survey" title="开户问卷调查" center :visible.sync="dialogFormVisible1"  width="35%" top="15vh" height="80%" :show-close="false" :modal-append-to-body="false" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="line"></div>
          <P>尊敬的客户：</P>
        <P>您好！为了保障您的权益，请您在开户前认真阅读并填写以下问卷。感谢您配合。祝您交易愉快！</P>
       <template>
         <p>1,   您是否自主开户？</p>
        <el-radio v-model="radio1" label="1">是</el-radio>
        <el-radio v-model="radio1" label="2">否</el-radio>
      </template>
      <template>
         <p>2,   您是否清楚交易风险？</p>
        <el-radio v-model="radio2" label="1">是</el-radio>
        <el-radio v-model="radio2" label="2">否</el-radio>
      </template>
      <template>
         <p>3,   您是否知晓风控细则？</p>
        <el-radio v-model="radio3" label="1">是</el-radio>
        <el-radio v-model="radio3" label="2">否</el-radio>
      </template>
      <template>
         <p>4,   您是否知晓账户交易手续费？</p>
        <el-radio v-model="radio4" label="1">是</el-radio>
        <el-radio v-model="radio4" label="2">否</el-radio>
      </template>
      <template>
         <p>5,   您的开户公司或代理人是否向您承诺了收益？</p>
        <el-radio v-model="radio5" label="1">是</el-radio>
        <el-radio v-model="radio5" label="2">否</el-radio>
      </template>
      <template>
         <p>6,   您是否自主交易？</p>
        <el-radio v-model="radio6" label="1">是</el-radio>
        <el-radio v-model="radio6" label="2">否</el-radio>
      </template>
      <template>
         <p>7,   您是否自主保管交易账户密码？</p>
        <el-radio v-model="radio7" label="1">是</el-radio>
        <el-radio v-model="radio7" label="2">否</el-radio>
      </template>
       <div class="line1"></div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible()" size="small">提交</el-button>
      </div>
    </el-dialog>
    <!-- 验证不正确弹框 -->
    <el-dialog
      :visible.sync="dialogVisible2"
      width="35%"
      :modal-append-to-body="false"
      class="diglog-risk"
      >
      <span>您的开户存在风险，为了保障您的权益，请了解风险后再注册。</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 风险提示书 -->
    <el-dialog
      title="【风险揭示书】"
      :visible.sync="dialogVisible"
      class="risk-wraning"
      width="80%"
      top="8vh"
      center=""
      :modal="true"
      :modal-append-to-body="false">
      <span>您使用软件之前，必须仔细阅读下面的内容，以便全面地了解使用软件的风险。</span>
      <p> 软件系统通过交易所的行情发布商，专线接入交易所获取行情数据，交易网关后台对接证券/期货的交易结算系统的开放接口。软件系统已经尽可能采取有效措施保护交易活动的安全，尽管如此，本着对用户负责的态度，在此提醒用户，使用本软件存在且不限于下列风险：</p>
      <p> (一) 在不限于以下故障情况出现时，可能会使您的委托指令无法发出，或产生错误指令：</p>
      <p>（1）系统与交易所、证券/期货公司的远程数据通讯线路发生故障，而交易所还在正常进行交易。</p>
      <p>（2）系统的计算机设备出现故障，而交易所还在正常进行交易。</p>
      <p>（3）用户交易终端与后台系统的通讯线路发生故障，而证券/期货公司和交易所还在正常交易。</p>
      <p>（4）突然停电而导致计算机系统中断。</p>
      <p>（5）用户设置好程序化以后，退出软件或关机。</p>
      <p>（6）用户在交易过程中因自身原因进行的误操作。</p>
      <p>（7）其他不可预测的系统风险或者技术风险。</p>
      <p>(二) 委托交易的数据传输可能因通讯繁忙或丢包等原因出现中断、停顿、延迟、数据错误、丢失或不完全，造成交易出现延迟、停顿、中断，从而会发生您不能及时、完整完成交易的风险。因此，您在使用该软件时，及时查证核实成交情况。</p>
      <p>(三) 由于出现网络故障或网络繁忙或交易网关负载过重，或因受到网络黑客、网络病毒的攻击和入侵等原因，软件可能会出现故障，您可能不能及时进入或通过该系统进行正常交易，或接到错误信息，或不能使用软件提供的全部或部分功能（包括但不限于各种自助和预设触发条件的下单功能等）。鉴于上述风险的存在，您在使用本软件的时候，应当使用其它信息系统或其它交易手段进行验证，并及时查证成交情况。</p>
      <p>(四) 软件发布的行情信息及其它证券/期货信息，因为网络延时等原因有可能出现错误或被误导，从而导致您做出错误判断，因此，您在使用该软件时，应对比其他软件，或采用其它手段，并及时查对行情数据。</p>
      <p>(五) 条件单和止损单，设定委托发出的条件，当条件满足时，交易系统将委托单自动报入交易所，当条件不满足时，委托单保留在云端服务器中。</p>
      <p>(六) 程序化模型所发出买卖讯号之建议，乃依据特定数学公式计算所得结果，仅供交易参考，据此入市，盈亏自负。</p>
      <p>(七) 软件的条件单、止损单等，对操作者有一定的交易经验与基础要求，请慎重考虑使用。</p>
      <p>(八) 由于交易所交易规则所限，软件中包括但不限于各种自助和预设触发条件的下单功能所发生的交易委托不一定能够成交。</p>
      <p>(九) 由于用户对开户资料、交易账户、交易密码等重要资料保护不当，造成被他人盗用，仿冒而产生的亏损由用户自己负责。</p>
      <p>由于您开立的证券/期货交易账户交由他人使用，出现未按您本人意图买卖证券/期货合约和提取资金的情况，所产生的后果由您本人承担。本揭示书未能尽述一切有关软件电子交易风险的重要事项，用户应该在细心研究、熟悉软件后，方可使用。证券/期货公司和软件提供方，都不会因为您使用或无法使用该软件而造成的损失承担责任。</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  </div>

</template>

<script>
import "../assets/lib/jquery.min.js";

export default {
  name: "register",
  data() {
    var pswdreg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[!@#$%^&*a-zA-Z\d]{8,48}$/;
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      }else if (value.length < 8) {
        callback(new Error("新密码长度不能低于8位！"));
      }else if (!pswdreg.test(value)) {
        callback(new Error("新密码必须包含大写字母,小写字母,数字,不能包含特殊符号！"));
      }else if (pswdreg.test(value)) {
         if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var reg = /^1\d{10}$/;
    var validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电话号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的11位手机号码"));
      } else {
        callback();
        this.codephone = true;
      }
    };
    return {
      InsName: "",
      pageId: "registerb",
      radio1: "",
      radio2: "",
      radio3: "",
      radio4: "",
      radio5: "",
      radio6: "",
      radio7: "",
      insCode: "",
      agentId: "",
      loading: false,
      loadingDialog: false,
      IsSimulation:"",
      IsSimulationshow:true,
      IsSimulationinput:false,
      isDisableds: false,
      codephone: false,
      dialogVisible: false,
      dialogFormVisible1: true,
      dialogVisible2: false,
      dialogVisibleCode: false,
      checked: false,
      buttonName: "发送短信验证码",
      isDisabled: false,
      time: 60,
      ruleForm: {
        Name: "",
        insUserCode: "",
        phone: "",
        phoneCode: "",
        pass: "",
        checkPass: "",
        delivery: false,
        Invitationcode:"",
        code:"",
      },
      ruleForm1: {
        code: "",
      },
      rules1: {
        code: [{required: true,  trigger: "blur",  message: "图形验证码不能为空！",}],
      },
      rules: {
        pass: [{required: true, validator: validatePass, trigger: "blur" }],
        checkPass: [{required: true, validator: validatePass2, trigger: "blur" }],
        Name: [
          {
            required: true,
            min: 2,
            max: 10,
            message: "真实姓名至少包含两个汉字（注意是否含有空格）",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, trigger: "blur", validator: validPhone } //这里需要用到全局变量
        ],
        code: [{required: true,  trigger: "blur",  message: "图形验证码不能为空！",}],
        phoneCode: [
          {
            required: true,
            message: "请输入正确的验证码",
            trigger: "blur"
          }
        ],
        Invitationcode:[{required: true,  trigger: "blur",  message: "邀请码不能为空！",}]
      },
      callbackurl:"",
      imgurl:"",
      ImageCheckSign:"",
      insTestProp: {
        IsTestIns: true, // 是否测试机构，true测试机构
        UserRelyPhone: true, // 依赖手机号
        UseCustomId: true // 使用自定义ID,false表示使用系统自动生成，true表示使用自定义ID
      }
    };
  },
  mounted(){
         // 判断pc还是app
      // if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      //   // console.log("这个是H5")
      //   // this.Source = "APP";
      //   $($(".el-dialog--center")[0]).css("width","80%")
      //   $($(".el-dialog")[1]).css("width","80%")
      //   $($(".el-dialog--center")[0]).css("margin-top","1vh")
      //   $("#registerb").css("width","100%")
      //   $("#Rtitle").css("padding-left","30px")
      //   $("#Rmin").css("width","100%")
      //   $(".el-form-item__content").css("margin-left","20px")
      //   $(".error4").css("display","block")
      //   $(".el-form-item").css("margin-bottom","0")
      //   $(".el-checkbox").css("margin","0 0 0 20px")
      //   $(".bbtn").css("margin","20px 40px");
      //   $(".el-form-item").css("margin-top","10px")
      // } else {
      //   // this.Source = "PC";
      // }
      var screenWidth = document.body.clientWidth;
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) || screenWidth <= 600) { // mobile
        this.pageId = "mobile-reg";
      }else{ // pc

      };   
  },
  created(){
		
		
    //根据?判断页面是哪里传过来的
    let current_insname=window.location.href;
    //  false代表手机端，true代表电脑
    let pcormo_status=current_insname.indexOf("?")==-1;
    let config_instoregister=JSON.parse(sessionStorage.getItem('InsToRegisterUrl'));
    let urlqz=current_insname.split("#")[0];

    if(pcormo_status){  //电脑端
  
      if(config_instoregister){
        
        var insname=current_insname.split("/")[5];
        
        if(insname){
          
          if(config_instoregister[insname]){
            
            window.location.href=config_instoregister[insname];
            
            return false;
            
          }else if(config_instoregister[insname]==""){
            
            window.location.href=urlqz+"#/contactadministrator"
          }
        }

    }

    }else{  //手机端

        let inskeyval=current_insname.split("?")[1];     
        let insnamec=inskeyval.split("=")[1];
  
        if(config_instoregister){
            
            if(insnamec){

                if(config_instoregister[insnamec]){
                    
                    window.location.href=config_instoregister[insnamec];
            
                    return false;
                }else if(config_instoregister[insnamec]==""){
            
                  window.location.href=urlqz+"#/contactadministrator"
                }
            }
        }
   

    }

		//如果不在json里配置InsToRegisterUrl键值对则无法进入本页面
		
		
		
    this.InsName = JSON.parse(sessionStorage.getItem("InsNameCn"));
      // if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) { // mobile
      //   this.pageId = "mobile-reg";
      // }else{ // pc

      // };
      let str = window.location.href;
      // 推广页跳转过来参数
      if(str.indexOf("?") != -1){
        this.insCode = this.$route.query.insCode;
        if(this.insCode == undefined){
           this.dialogFormVisible1 = false;
           this.$message.error("推广链接地址错误,请联系管理员！");     
           return;     
        }
        let postData = "insCode=" +  this.insCode
        let url = "/register/GetInsTestProp";
        this.$api.post(url,postData, response => {
          if (response.Ret == 0) {
            this.insTestProp = response.Data;
            if (!this.insTestProp.UserRelyPhone) {
              this.rules.phone = [];
              this.rules.phoneCode = [];
            }
            if(!this.insTestProp.IsTestIns){
                this.IsSimulation = 0;
            }else{
                this.IsSimulation = 1; 
                this.IsSimulationshow=false;
                this.ruleForm.Name = "模拟";
                this.IsSimulationinput = true;
                this.rules.pass = [];
            }
          } else {
            this.$message.error(response.Msg);
          }
        });
        if(this.$route.query.agentId == null || this.$route.query.agentId == undefined){
             this.ruleForm.Invitationcode = "";
        }else{
             this.ruleForm.Invitationcode = this.$route.query.agentId;
        }      
        if(this.ruleForm.Invitationcode == undefined){
           this.ruleForm.Invitationcode = "";
        }
      }else{
        // 登录页跳转过来
        // this.insTestProp = JSON.parse(sessionStorage.getItem("insTestProp"));
        // if (!this.insTestProp.UserRelyPhone) {
        //   this.rules.phone = [];
        //   this.rules.phoneCode = [];
        // }
        // if(!this.insTestProp.IsTestIns){
        //   this.IsSimulation = 0;
        //   this.insCode = str.split("/")[5];
        // }else{
        //   this.IsSimulation = 1;
        //   this.insCode = str.split("/")[5];
        //   this.IsSimulationshow = false;
        //   this.ruleForm.Name = "模拟";
        //   this.IsSimulationinput = true;          
        // }          
        this.insCode = str.split("/")[5];
        let postData = "insCode=" +  this.insCode
        let url = "/register/GetInsTestProp";
        this.$api.post(url,postData, response => {
          if (response.Ret == 0) {
            this.insTestProp = response.Data;
            if (!this.insTestProp.UserRelyPhone) {
              this.rules.phone = [];
              this.rules.phoneCode = [];
            }
            if(!this.insTestProp.IsTestIns){
                this.IsSimulation = 0;
            }else{
                this.IsSimulation = 1; 
                this.IsSimulationshow=false;
                this.ruleForm.Name = "模拟";
                this.IsSimulationinput = true;
                this.rules.pass = [];
            }
          } else {
            this.$message.error(response.Msg);
          }
        });          
      }
      sessionStorage.setItem("insCode",this.insCode);
      document.getElementsByTagName("title")[0].innerText = '账户注册'; 
      this.callbackurl = this.$route.query.callbackurl;
      sessionStorage.setItem("callbackurl",this.callbackurl);   
      this.GetImgCheckCode();    
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //  获取图形验证码
    GetImgCheckCode(){
        this.$api.post(
        "/login/GetImgCheckCode","id="  + this.insCode,
        // "",
        response => {
            if (response.Ret == 0) {  
              this.imgurl = "data:image/png;base64," + response.Data.ImageBase64;
              this.ImageCheckSign = response.Data.ImageCheckSign;
            } else {
              this.$message.error(response.Msg);    
            }
        });           
    },
    // 注册按钮
    submitForm(formName) {
      if(this.insCode == undefined){
           this.$message.error("未获取机构,请联系管理员！");     
           return;     
      }
      this.$refs[formName].validate(valid => {
        if(this.checked == false){
          vue.$message.error({
            duration:1000,
            message:"请阅读交易系统使用风险揭示书并同意！"});
          return;
        }
        if (this.insTestProp.UseCustomId) {
         if (this.ruleForm.insUserCode == '' || this.ruleForm.insUserCode == null) {
           this.$message.error("请输入用户账号！");
           return;
         }
        }
        if (valid && this.checked === true) {
          let url = "register/RegisterInsUser";
          /**
            新接口, 原字段 name  改为 insUserName
          */
          // let url = "register/RegisterInsUserNew";
          let postData = "";
          var imageCode = '';
          if (this.insTestProp.UserRelyPhone) {
            imageCode = this.ruleForm1.code;
          } else {
            imageCode = this.ruleForm.code;
          }
          if(this.IsSimulation == 0){
            if(this.ruleForm.Invitationcode == ""){
              this.$message.error("邀请码不能为空！");
              return;
            }
             postData =
            "insCode=" +
            this.insCode +
            "&insUserCode=" +
            this.ruleForm.insUserCode + 
            "&insUserName=" +
            this.ruleForm.Name +
            "&Phone=" +
            this.ruleForm.phone +
            "&Code=" +
            this.ruleForm.phoneCode +
            "&pwd=" +
            this.ruleForm.pass +
            "&inviteCode=" +
            this.ruleForm.Invitationcode +
            "&imageCode=" +
            imageCode +
            "&imageCheckSign=" +
            this.ImageCheckSign;    
          }else if(this.IsSimulation == 1){
          // if(this.ruleForm.Invitationcode == ""){
          //   this.$message.error("邀请码不能为空！");
          //   this.ruleForm.Name = "模拟";
          //   return;
          // }
            postData =
            "insCode=" +
            this.insCode +
            "&insUserCode=" +
            this.ruleForm.insUserCode + 
            "&insUserName=" +
            this.ruleForm.Name +
            "&Phone=" +
            this.ruleForm.phone +
            "&Code=" +
            this.ruleForm.phoneCode +
            "&pwd=" +
            this.ruleForm.pass +
            "&inviteCode=" +
            this.ruleForm.Invitationcode +
            "&imageCode=" +
            imageCode +
            "&imageCheckSign=" +
            this.ImageCheckSign;            
          }
          this.loading = true;
          this.isDisableds = true;
            this.$api.post(url, postData, response => {
            this.isDisableds = false;
            this.loading = false;
            if (response.Ret == 0) {          
                    $("#name").val("");
                    $("#phone").val("");
                    $("#code").val("");
                    $("#pswd").val("");
                    $("#pswds").val("");
                    $("#Invitationcode").val("");
                     this.$alert("恭喜，注册成功，您的账号为：" + response.Data + "，请妥善保存！", "", {
                      confirmButtonText: "确定",
                      callback: action => {
                        this.$router.push("/registersuccess?insCode=" + this.insCode);
                      }
                    });
                    // setTimeout(() => {
                    //   this.$router.push("/registersuccess");
                    // }, 1000);
                    // if(this.IsSimulation == 1){
                    //       vue.$alert("模拟账户已注册，请登录模拟端体验。",  {
                    //       confirmButtonText: '确定',
                    //       callback: action => {
                    //         window.location.reload();
                    //       }
                    //     }); 
                    // }else if(this.IsSimulation == 0){
                    //   vue.$message.success("注册成功！自动跳转登录页面！");
                    //   setTimeout(() => {
                    //   this.$router.push("/registersuccess");
                    //   }, 1000);
                    // }
            } else {
               this.$message.error(response.Msg);
               this.GetImgCheckCode();
                this.ruleForm.code = "";
               if(this.IsSimulation == 1) {
                 this.ruleForm.Name = "模拟";
               }
            }
          });
        } else {
          vue.$message.error("信息输入有误！");
          return false;
        }
      });
    },

    dialogFormVisible() {
      if (
        this.radio1 == "1" &&
        this.radio2 == "1" &&
        this.radio3 == "1" &&
        this.radio4 == "1" &&
        this.radio5 == "2" &&
        this.radio6 == "1" &&
        this.radio7 == "1"
      ) {
        this.dialogFormVisible1 = false;
      } else {
        this.dialogVisible2 = true;
      }
    },
   sendPhoneCode (formName) {
      if(this.ruleForm1.code == ""){
        this.$message.error("请输入图形验证码");
        return;
      }
      let url = "register/RegisterInsUserSendSmsCode";
      this.loadingDialog = true;
      this.$api.post(url,
      "phone=" + this.ruleForm.phone + "&imageCode=" + this.ruleForm1.code + "&imageCheckSign=" + this.ImageCheckSign
      , response => {
        this.loadingDialog = false;
        this.dialogVisibleCode = false;
        if (response.Ret == 0) {
          this.$message.success("验证码已发送，请注意查收!");
          this.sendMsg();
          this.codephone = false;
        } else {
          // this.GetImgCheckCode();
          this.ruleForm1.code = "";
          this.$message.error(response.Msg);
        }
      });
    },
    //获取验证码
    sendCode() {
        if(this.insCode == undefined){
           this.$message.error("未获取机构,请联系管理员！");     
           return;     
        }
        this.$refs.ruleForm.validateField("phone", errMsg => {
          if (errMsg) {
            this.$message.error("请输入正确的手机号");
            return;
          } else {
            this.ruleForm1.code = '';
            this.GetImgCheckCode();
            this.dialogVisibleCode = true;
          }
        });
        // let url = "register/RegisterInsUserSendSmsCode";
        // this.$api.post(url,
        // "phone=" + this.ruleForm.phone + "&imageCode=" + this.ruleForm.code + "&imageCheckSign=" + this.ImageCheckSign
        // , response => {
        //   if (response.Ret == 0) {
        //     this.$message.success("验证码已发送，请注意查收!");
        //     this.sendMsg();
        //     this.codephone = false;
        //   } else {
        //     this.GetImgCheckCode();
        //     this.ruleForm.code = "";
        //     this.$message.error(response.Msg);
        //   }
        // });
    },
        // 短信验证倒计时
    sendMsg() {
      let me = this;
      me.isDisabled = true;
      let interval = window.setInterval(function() {
        me.buttonName = "（" + me.time + "s）发送";
        --me.time;
        if (me.time < 0) {
          me.buttonName = "发送短信验证码";
          me.time = 60;
          me.isDisabled = false;
          window.clearInterval(interval);
        }
      }, 1000);
    },
  }
};
</script>


<style>
#registerb .el-input {
  width: 50% !important;
}
#registerb .el-dialog__body {
  width: 100% !important;
}
#mobile-reg .el-input {
  width: 50% !important;
}
#mobile-reg .el-dialog__body {
  width: 100% !important;
}
#mobile-reg {
  width: 100%;
  height: 100%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
#mobile-reg .dialog-survey {
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
}
#mobile-reg .dialog-survey .el-dialog--center {
  width: 80% !important;
  margin-top: 10% !important;
  height: 90%;
}
#mobile-reg .dialog-survey .el-dialog__body {
  height: 80%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  border-bottom: 1px solid #ccc;
}
#mobile-reg #Rtitle{
  padding-left: 30px;
}
#mobile-reg #Rmin {
  width: 100%;
}
#mobile-reg .risk-wraning {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#mobile-reg .risk-wraning .el-dialog--center {
  height: 90% !important;
  margin-top: 10% !important;
  overflow: hidden;
}
#mobile-reg .risk-wraning .el-dialog__body{
  height: 80%;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  border-bottom: 1px solid #ccc;
}
#mobile-reg .diglog-risk .el-dialog{
  width: 80% !important;
}
#mobile-reg .dialog-code .el-dialog{
  width: 80% !important;
}
#mobile-reg .dialog-code .el-form{
  padding-top: 0 !important;
}
#mobile-reg .el-form-item__content {
  margin-left: 20px !important;
}
#mobile-reg .error4 {
  display: block;
}
#mobile-reg .el-form-item {
  margin-bottom: 0;
  margin-top: 10px;
}
#mobile-reg .el-checkbox {
  margin: 0 0 0 20px !important;
}
#mobile-reg .bbtn {
  margin: 20px 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue